import React, { memo } from 'react';
import { Box, IconButton, Button, Paper, Stack } from '@mui/material';
import { Refresh, SaveAlt } from '@mui/icons-material';

const AssignmentActionsBar = ({ onReload, onSelectAll, onExport, hasRows }) => {
    return (
        <Paper
            elevation={1}
            sx={{
                mb: 2,
                px: 2,
                py: 1.2,
                borderRadius: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                bgcolor: 'background.paper',
            }}
        >
            <Stack direction="row" spacing={1} alignItems="center">
                <IconButton
                    size="small"
                    color="primary"
                    onClick={onReload}
                    title="Reload with current filters"
                >
                    <Refresh fontSize="small" />
                </IconButton>
                <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    startIcon={<SaveAlt fontSize="small" />}
                    onClick={onExport}
                    disabled={!hasRows}
                >
                    Export
                </Button>
            </Stack>

            <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={onSelectAll}
            >
                Select All
            </Button>
        </Paper>
    );
};

export default memo(AssignmentActionsBar);
